import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Title from '@components/Forms/Title';
import CustomModal from '@components/Modal';
import { hideModal, setModalResult } from '@store/common/actions';
import { Button } from '@material-ui/core';

const ModalScreen = () => {
  const {
    title,
    showModal,
    paragraph,
    subtitle,
    imgSrc,
    firstButtonClass,
    firstButtonText,
    respOnClickFirst,
    showSecondButton,
    secondButtonClass,
    secondButtonText,
    respOnClickSecond,
  } = useSelector((state) => state.common?.modal || {});
  const dispatch = useDispatch();

  const dispatchHideModal = () => dispatch(hideModal());

  const onClickedButton = (text) => {
    dispatch(setModalResult(text));
    hideModal();
  };

  return (
    <CustomModal title={title} open={showModal || false} handleClose={() => dispatchHideModal()}>
      <Grid
        container
        direction="column"
        item
        xs={12}
        justifyContent="center"
        style={{ textAlign: 'center', padding: 20 }}
      >
        {imgSrc && <img src={imgSrc} alt="modal" />}
        <Grid
          container
          direction="column"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          item
          xs={12}
        >
          {subtitle && <Title style={{ textAlign: 'center', fontSize: 16 }} text={subtitle} />}
          {paragraph && (
            <div
              style={{
                paddingTop: 11,
                width: 280,
                color: '#838aa2',
                fontSize: 12,
              }}
            >
              {paragraph}
            </div>
          )}
          <Button
            id="mdl_btn_first"
            className={firstButtonClass || ''}
            onClick={() => onClickedButton(respOnClickFirst)}
            style={{
              marginTop: 20,
              width: 176,
              height: 32,
              padding: '7px 15px',
            }}
          >
            {firstButtonText}
          </Button>
          {showSecondButton && (
            <Button
              className={secondButtonClass}
              id="mdl_btn_second"
              onClick={() => onClickedButton(respOnClickSecond)}
              variant="outlined"
              style={{
                marginTop: 16,
                width: 176,
                height: 32,
                padding: '7px 15px',
              }}
            >
              {secondButtonText}
            </Button>
          )}
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default ModalScreen;
